import { memo } from "react";

import { TEST_ID_COMPARE_PLAYER } from "e2e/testId";

import { Pressable } from "@/components/atoms/Pressable";
import { Text } from "@/components/atoms/Text";
import { PlayerCardData } from "@/types/playerCardTypes";

/**
 * Props for the PlayerCompareItemView component
 */
interface PlayerCompareItemViewProps {
  item: PlayerCardData;
  index: number;
  isSmallScreen: boolean;
  onPress: () => void;
}

/**
 * View component for a single player item in the compare list.
 * Displays the player name with responsive font sizing.
 * @param root0 - Component props
 * @param root0.item - The player data to display
 * @param root0.index - Index of the item in the list (used for styling)
 * @param root0.isSmallScreen - Whether the screen is small (mobile)
 * @param root0.onPress - Callback when player item is pressed
 */
const PlayerCompareItemView = ({
  item,
  index,
  isSmallScreen,
  onPress,
}: PlayerCompareItemViewProps) => (
  <Pressable
    testID={TEST_ID_COMPARE_PLAYER.MY_ROSTER_PLAYER_ITEM}
    onPress={onPress}
    className={`${index === 0 ? "" : "pt-4"}`}
  >
    <Text
      variant="unstyled"
      className={`shrink text-left font-medium ${!isSmallScreen ? "text-title-sm" : "text-title"}`}
    >
      {item.name}
    </Text>
  </Pressable>
);

PlayerCompareItemView.displayName = "PlayerCompareItemView";

export default memo(PlayerCompareItemView);
